// extracted by mini-css-extract-plugin
export var currencyInput = "_m1-1";
export var currencySymbol = "_m1-0";